const amenities = ['amps_30', 'amps_50', 'back_in', 'amps_20', 'amps_100', 'ac']
const nightPrice = { displayWithCode: '$0.00 ABC' }

export const ratesToShowInLoading = [{ amenities, description: 'Loading...', id: 'Loading 1', name: 'Loading...',
                                       nightPrice, pictureUrl: 'KEEP_LOADING', type: 'type_rv_site' }]
